<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-chart-simple"></i>
    {{ texts.analysisCreated[language] }}
    <div scActivityBody>
        @if (matchCount) {
        <p>{{ texts.analysisMatchesPrefix[language] }} {{ matchCount | number : '1.0-0' }} {{ texts.analysisMatchesSuffix[language] }}</p>
        }
    </div>
</sc-activity-list-item>
